module.exports = __webpack_public_path__ + "cce681c836a6486adb740374be888b0d.png";


//////////////////
// WEBPACK FOOTER
// ./lib/core/resources/img/icons.png
// module id = 1139
// module chunks = 0